import {copyVectorArray} from "./threeUtils";
import {Line3} from "three";
import {calculateLinesIntersecting} from "./mathUtils";

export function polygonNonSelfIntersecting(points) {
    let lines = [];
    points = copyVectorArray(points, true);
    points.pop();

    for (let i = 0; i < points.length; i++) {
        let currentPoint = points[i];
        let nextPoint = i === points.length - 1 ? points[0] : points[i + 1];
        let line = new Line3(currentPoint, nextPoint);
        lines.push(line);
    }

    for (let i = 0; i < lines.length; i++) {
        let currentLine = lines[i];
        for (let j = 0; j < lines.length; j++) {
            let lineToCheck = lines[j];
            if (lineToCheck === currentLine) {
                continue;
            }

            let result = calculateLinesIntersecting(currentLine.start.x, currentLine.start.z, currentLine.end.x, currentLine.end.z, lineToCheck.start.x, lineToCheck.start.z, lineToCheck.end.x, lineToCheck.end.z);
            if (result.intersects) {
                let intersectionPoint = result.point;
                if (intersectionPoint !== currentLine.start && intersectionPoint !== currentLine.end && intersectionPoint !== lineToCheck.start && intersectionPoint !== lineToCheck.end) {
                    return false;
                }
            }
        }
    }


    return true; // no intersections found, polygon is not self-intersecting
}
